<app-header headerText="Parámetros Préstamos En Lista de Espera"></app-header>
<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true
  (selectedTabChange)="loadLoanList($event)">
  <!--mat-tab [disabled]='isEdit'>
    <ng-template mat-tab-label>
      <mat-icon>add</mat-icon>
      Nueva Lista <br>de Espera
    </ng-template>
    <div class="row py-2 border-bottom">
      <div class="col-md-4 offset-md-4">
        <mat-form-field>
          <input matInput placeholder="Nombre Del Nuevo Ciclo:" [(ngModel)]="loanListParameters.title" type="text"
            [formControl]="name" (keyup)="keyUpMethod($event.target.value)" required>
          <mat-error *ngIf="name.invalid">{{getErrorMessage()}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <app-pending-list-parameters-options [loanListParameters]="loanListParameters" [ngClass]="{'blocked': !isNew}"
      [contentLocation]="contentLocation"></app-pending-list-parameters-options>
    <div class="row px-3 my-4" [ngClass]="{'blocked': !isNew}">
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-block btn-outline-secondary" (click)="cancelChanges()">Cancelar</button>
      </div>
      <div class="col-md-4">
        <button class="btn btn-block btn-primary" (click)="saveLoanListParam();">Guardar Cambios</button>
      </div>
    </div>
  </mat-tab-->

  <mat-tab >
    <ng-template mat-tab-label>
      <mat-icon>edit</mat-icon>
      Ciclos<br>Lista de Espera
    </ng-template>
    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">
        <mat-form-field>
          <mat-select placeholder="Nombre Lista de Espera:" (selectionChange)="selectedListChange($event)"
            [value]="loanListParameters">
            <mat-option>Seleccione el ciclo</mat-option>
            <mat-option *ngFor="let element of savingParameters" [value]="element">
              {{element.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
    <br>
    <app-pending-list-parameters-options *ngIf="loanListParameters.title != ''"
      [loanListParameters]="loanListParameters" [contentLocation]="contentLocation">
    </app-pending-list-parameters-options>
    <div *ngIf="loanListParameters.title != ''" class="row px-3 my-4" >
      <div class="col-md-4 offset-md-4">
        <button class="btn btn-block btn-outline-secondary" (click)="cancelChanges()">Cancelar</button>
      </div>
      <div class="col-md-4">
        <button class="btn btn-block btn-primary" (click)="saveLoanListParam();">Guardar Cambios</button>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>